import React from 'react';
import './Header.scss'

function Header() {
  return (
    <header>
        <div className="title">
          <div>
            <img src="Gluc.png" alt="Gluc Logo" width="80" height="80" />
            <h1>GLUC</h1>
          </div>
        </div>
  </header>
  );
}

export default Header;
